let restoringState = false;

let enrichedProductData = null;

function getProductData() {
  if (enrichedProductData) return enrichedProductData;

  const rawProductJson = document.querySelector(".product-json");
  if (rawProductJson) {
    try {
      enrichedProductData = JSON.parse(
        rawProductJson.textContent || rawProductJson.innerHTML,
      );
      return enrichedProductData;
    } catch (e) {
      // Fall back to window.productData when embedded JSON is unavailable/invalid.
    }
  }

  enrichedProductData = window.productData || null;
  return enrichedProductData;
}

// Save the state of size and filling to be restored on variant change
const state = {
  size: null,
  filling: null,
  tog: null,
};

// --------------------------------------
// Helper functions to save and load states
// --------------------------------------

// Save states to sessionStorage
function saveState() {
  sessionStorage.setItem("size", state.size || "");
  sessionStorage.setItem("filling", state.filling || "");
  sessionStorage.setItem("tog", state.tog || "");
}

// Load states from sessionStorage
function loadState() {
  state.size = sessionStorage.getItem("size") || null;
  state.filling = sessionStorage.getItem("filling") || null;
  state.tog = sessionStorage.getItem("tog") || null;
}

function getOptionKeyByName(productData, optionName) {
  if (!productData || !Array.isArray(productData.options)) return null;

  const index = productData.options.findIndex((option) =>
    (option || "").toLowerCase().split(" ")[0].trim().includes(optionName),
  );

  if (index < 0) return null;

  return `option${index + 1}`;
}

function optionValueMatches(variantValue, selectedValue) {
  const variantText = (variantValue || "").toString().trim().toLowerCase();
  const selectedText = (selectedValue || "").toString().trim().toLowerCase();

  if (!variantText || !selectedText) return false;

  // Exact match first.
  if (variantText === selectedText) return true;

  // Support composite option values like "single / 4.5 tog" where the stored
  // size state ("single") needs to match the size portion of a compound variant
  // option value. Split on " / " and check each part as a whole word only.
  const variantParts = variantText.split(" / ").map((p) => p.trim());
  const selectedParts = selectedText.split(" / ").map((p) => p.trim());

  return selectedParts.some((sp) => variantParts.some((vp) => vp === sp));
}

// Get correct variant from state
function getVariantFromState() {
  const productData = getProductData();
  if (!productData || !Array.isArray(productData.variants)) return null;

  if (!state.size) return null;

  const sizeKey = getOptionKeyByName(productData, "size");
  const fillingKey = getOptionKeyByName(productData, "filling");
  const togKey = getOptionKeyByName(productData, "tog");

  if (!sizeKey) return null;

  // 1. Find size match only first
  const sizeMatch = productData.variants.find((variant) =>
    optionValueMatches(variant[sizeKey], state.size),
  );

  if (!sizeMatch) return null;

  const refined = productData.variants.find((variant) => {
    if (!optionValueMatches(variant[sizeKey], state.size)) return false;

    if (state.filling && fillingKey) {
      if (!optionValueMatches(variant[fillingKey], state.filling)) return false;
    }

    if (state.tog && togKey) {
      if (!optionValueMatches(variant[togKey], state.tog)) return false;
    }

    return true;
  });

  return refined || sizeMatch;
}

// Set the variant ID in the cart form, to ensure the correct variant is added to cart
function setCartVariantId(variantId) {
  const input =
    document.querySelector('form [name="id"]') ||
    document.querySelector('[name="id"]');

  if (!input) return;

  input.value = variantId;
  input.dispatchEvent(new Event("change", { bubbles: true }));

  // Fallback for any custom JS that reads the variant ID directly from a global variable
  window.currentVariantId = variantId;
}

// Keep theme listeners (accordion/specs/stock badges/etc.) in sync with custom state changes.
function notifyThemeVariantChange(variant) {
  if (!variant || !window.Events || typeof window.Events.trigger !== "function")
    return;

  window.Events.trigger("variantchange", variant);
  window.Events.trigger("variantchange:option1:" + (variant.option1 || ""));
  window.Events.trigger("variantchange:option2:" + (variant.option2 || ""));
  window.Events.trigger("variantchange:option3:" + (variant.option3 || ""));
}

function syncAccordionSpecData(variant) {
  if (!variant) return;

  const fieldMap = {
    width_cm: variant.width_cm,
    height_cm: variant.height_cm,
    depth_cm: variant.depth_cm,
    width_in: variant.width_in,
    height_in: variant.height_in,
    weight: (variant.weight_in_unit || "") + (variant.weight_unit || ""),
  };

  Object.keys(fieldMap).forEach((key) => {
    const target = document.querySelector(".product-spec ." + key);
    if (!target) return;
    target.textContent = fieldMap[key] == null ? "" : fieldMap[key];
  });
}

// Update price and SKU on the page manually
function applyVariant(variant) {
  if (!variant) return;

  updatePrice(variant.price);
  updateSku(variant.sku);

  setCartVariantId(variant.id);
  notifyThemeVariantChange(variant);
  syncAccordionSpecData(variant);

  const el = document.querySelector("[data-product-sku]");
  if (el) el.dataset.productSku = variant.sku;

  setTimeout(() => {
    const variant = getVariantFromState();
    if (variant) setCartVariantId(variant.id);
  }, 100);
}

// Sync the selected variant based on the current state (size + filling)
function syncVariant() {
  const variant = getVariantFromState();

  if (!variant) return;

  applyVariant(variant);
  setActiveBubble(state.size);
}

// Handle size change from either select or bubbles
function handleSizeChange(value) {
  state.size = value;
  saveState();
  syncVariant();
}

// Handle filling change from radio buttons
function handleFillingChange(value) {
  state.filling = value;
  saveState();
  syncVariant();
}

function handleTogChange(value) {
  state.tog = value;
  saveState();
  syncVariant();
}

// Restore UI based on saved state
function restoreUI(sizeSelect, fillingInputs) {
  const savedSize = state.size;
  const savedFilling = state.filling;
  const savedTog = state.tog;

  // restore select OR bubbles visually only
  if (sizeSelect.tagName === "SELECT" && savedSize) {
    sizeSelect.value = savedSize;
  }

  document
    .querySelectorAll("#variant-selector-size .variant-bubble")
    .forEach((bubble) => {
      bubble.classList.toggle("active", bubble.dataset.value === savedSize);
    });

  if (savedFilling && fillingInputs.length) {
    const match = [...fillingInputs].find(
      (input) => input.value === savedFilling,
    );
    if (match) match.checked = true;
  }

  if (savedTog) {
    const match = document.querySelector(
      `input[name="tog"][value="${savedTog}"]`,
    );
    if (match) match.checked = true;
  }

  syncVariant();
}

// Set active class on bubbles based on selected size
function setActiveBubble(value) {
  document
    .querySelectorAll("#variant-selector-size .variant-bubble")
    .forEach((bubble) => {
      bubble.classList.toggle("active", bubble.dataset.value === value);
    });
}

// Wait for size options to be available in the DOM before trying to restore state
function waitForSizeOptions(callback) {
  const sizeSelect = document.getElementById("variant-selector-size");

  const interval = setInterval(() => {
    if (!sizeSelect) return;

    const hasOptions =
      sizeSelect.querySelectorAll("option").length > 0 ||
      document.querySelectorAll(".select2-container").length > 0;

    if (!hasOptions) return;

    clearInterval(interval);
    callback();
  }, 50);

  setTimeout(() => clearInterval(interval), 3000);
}

// Only run on product pages
document.addEventListener("DOMContentLoaded", function () {
  const onProductPage = !!document.querySelector(
    "#js-addtocart-popup-ctl, #range-products",
  );

  if (!onProductPage) return;

  const sizeSelect = document.getElementById("variant-selector-size");
  const fillingInputs = document.querySelectorAll('input[name="filling"]');
  const togInputs = document.querySelectorAll('input[name="tog"]');

  loadState();

  // On initial page load, sync OptionSelectors to the currently-rendered size
  // so availability is correct before any bubble is clicked.
  //
  // theme.js loads `async` so jQuery's ready (which creates OptionSelectors and
  // attaches set_availability listeners) may run well after DOMContentLoaded and
  // even after setTimeout(0). We poll until the single-option-selector elements
  // that OptionSelectors creates actually exist, then fire the sync.
  (function syncInitialSize() {
    const sizeContainer = document.getElementById("swatches__container--size");
    if (!sizeContainer) return;

    const activeBubble = sizeContainer.querySelector(".variant-bubble.active");
    if (!activeBubble) return;

    const value = activeBubble.dataset.value;
    if (!value) return;

    // Prime state so getVariantFromState works on first tog/filling change.
    if (!state.size) {
      state.size = value;
    }

    const optionPos = parseInt(sizeContainer.dataset.optionIndex, 10) - 1;

    function attemptSync() {
      const optionSelectors = document.querySelectorAll(
        ".single-option-selector",
      );
      const sizeOptionSelector = optionSelectors[optionPos];

      if (!sizeOptionSelector) {
        // OptionSelectors not yet initialised — retry on next frame.
        requestAnimationFrame(attemptSync);
        return;
      }

      if (sizeOptionSelector.value !== value) {
        sizeOptionSelector.value = value;
      }

      sizeOptionSelector.dispatchEvent(new Event("change", { bubbles: true }));
    }

    requestAnimationFrame(attemptSync);
  })();

  /* -------------------------
    SIZE EVENTS
  --------------------------*/

  if (sizeSelect.tagName === "SELECT") {
    // Native fallback
    sizeSelect.addEventListener("change", (e) => {
      if (restoringState) return;

      setTimeout(() => {
        handleSizeChange(e.target.value);
      }, 0);
    });

    // Select2-safe binding
    if (window.jQuery && jQuery.fn.select2) {
      jQuery(sizeSelect).on("select2:select select2:change", function (e) {
        if (restoringState) return;

        setTimeout(() => {
          const value = e.params?.data?.id || e.target.value;
          handleSizeChange(value);
        }, 0);
      });
    }
  } else {
    document.addEventListener("click", (e) => {
      const bubble = e.target.closest(".variant-bubble");
      if (!bubble) return;

      const sizeBubbleGroup = bubble.closest("#variant-selector-size");
      if (!sizeBubbleGroup) return;

      const value = bubble.dataset.value;

      // Keep Shopify's OptionSelectors in sync so it can resolve the correct
      // variant (and enable the cart button) when tog/filling radios change.
      const sizeContainer = document.getElementById(
        "swatches__container--size",
      );
      if (sizeContainer) {
        const optionPos = parseInt(sizeContainer.dataset.optionIndex, 10) - 1;
        const optionSelectors = document.querySelectorAll(
          ".single-option-selector",
        );
        const sizeOptionSelector = optionSelectors[optionPos];
        if (sizeOptionSelector) {
          sizeOptionSelector.value = value;
          sizeOptionSelector.dispatchEvent(
            new Event("change", { bubbles: true }),
          );
        }
      }

      handleSizeChange(value);
      setActiveBubble(value);
    });
  }

  /* -------------------------
    FILLING EVENTS
  --------------------------*/

  fillingInputs.forEach((input) => {
    input.addEventListener("change", function () {
      handleFillingChange(this.value);
    });
  });

  togInputs.forEach((input) => {
    input.addEventListener("change", function () {
      handleTogChange(this.value);
    });
  });

  /* -------------------------
    RESTORE STATE
  --------------------------*/

  waitForSizeOptions(() => {
    const savedSize = state.size;
    const savedFilling = state.filling;
    const savedTog = state.tog;

    if (!savedSize && !savedFilling && !savedTog) return;

    restoringState = true;

    const sizeSelect = document.getElementById("variant-selector-size");

    // Restore size
    if (savedSize && sizeSelect?.tagName === "SELECT") {
      const exists = [...sizeSelect.options].some((o) => o.value === savedSize);
      if (!exists) return;

      if (window.jQuery && jQuery.fn.select2) {
        jQuery(sizeSelect).val(savedSize).trigger("change.select2");
      } else {
        sizeSelect.value = savedSize;
        sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // Restore bubbles
    document
      .querySelectorAll("#variant-selector-size .variant-bubble")
      .forEach((bubble) => {
        bubble.classList.toggle("active", bubble.dataset.value === savedSize);
      });

    // Restore filling
    if (savedFilling) {
      const match = document.querySelector(
        `input[name="filling"][value="${savedFilling}"]`,
      );

      if (match) match.checked = true;
    }

    if (savedTog) {
      const match = document.querySelector(
        `input[name="tog"][value="${savedTog}"]`,
      );
      if (match) match.checked = true;
    }

    syncVariant();

    restoringState = false;
  });

  // Save reference of last clicked size to sessionStorage on range pages, to be used on product page for pre-selection
  const rangeWrapper = document.querySelector("#js-range-products");

  if (rangeWrapper) {
    rangeWrapper.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const anchor = e.target.closest("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      const skuEl = document.querySelector("[data-product-sku]");

      if (!href || !skuEl) return;

      sessionStorage.setItem(
        "click-reference",
        JSON.stringify({
          type: "range",
          ref: skuEl.getAttribute("data-product-sku"),
        }),
      );

      if (
        JSON.parse(sessionStorage.getItem("click-reference")).ref ===
        skuEl.getAttribute("data-product-sku")
      ) {
        setTimeout(() => {
          window.location.href = href;
        }, 10);
      }
    });
  }
});
